import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { FolderTreeType } from '../../AccountFiles';
import T from 'Components/Helpers/translate';
import { Text } from '@upsales/components';
import { useDrop } from 'react-dnd';
import { isMeetingsFolder } from '../../fileRequests';

import './FolderTreeBranch.scss';

type Props = {
	folder: FolderTreeType | null;
	changeFolder: (folderId?: number | null) => void;
	lastInTree: boolean;
	dropDisabled?: boolean;
	setSearchString?: (text: null) => void;
	searchString?: string | null;
	changeFolderFolder: (id: number, folderId: number | null) => void;
	changeFileFolder: (id: number, folderId: number | null) => void;
	numberOfFolders: number;
	numberOfFiles: number;
};

const FolderTreeBranch = ({
	folder,
	changeFolder,
	lastInTree,
	dropDisabled = false,
	setSearchString,
	searchString,
	changeFolderFolder,
	changeFileFolder,
	numberOfFolders,
	numberOfFiles
}: Props) => {
	const classes = new BemClass('FolderTreeBranch');

	const [{ isOver }, drop] = useDrop(
		() => ({
			accept: 'ALL',
			canDrop: () => !dropDisabled && !isMeetingsFolder(folder?.id),
			drop: (item: { id: number; isFile: boolean }) => {
				if (item.isFile) {
					changeFileFolder(item.id, folder?.id ?? null);
				} else {
					changeFolderFolder(item.id, folder?.id ?? null);
				}
			},
			collect: monitor => ({ isOver: monitor.isOver() && monitor.canDrop() })
		}),
		[numberOfFolders, numberOfFiles, dropDisabled]
	);

	return (
		<div ref={drop} className={classes.mod({ isOver }).b()}>
			<Text
				bold={lastInTree}
				onClick={() => {
					if (typeof searchString === 'string') {
						setSearchString?.(null);
						return;
					} else {
						changeFolder(folder?.id);
					}
				}}
			>
				{folder?.name || T('file.documents')}
			</Text>
		</div>
	);
};

export default FolderTreeBranch;
